export default __webpack_public_path__ + "static/Device-lifecycle-solution-3cbf039480c79102421c8ca51ebdfa08.webp";